import {NavLink} from 'react-router-dom';
function NavMain({navShow}) {
    return (
        <nav className={navShow ? 'main-nav show' : 'main-nav'}>
            <ul>
                <li><NavLink className="hover-underline-animation" to="/">Home</NavLink></li>
                <li><NavLink className="hover-underline-animation" to="/about">About</NavLink></li>
                <li><NavLink className="hover-underline-animation" to="/projects">Projects</NavLink></li>
                <li><NavLink className="hover-underline-animation" to="/contact">Contact</NavLink></li>
            </ul>
        </nav>
    )
}

export default NavMain;
